import React from "react";
import PropTypes from "prop-types";
import classnames from "classnames";

const TextFlag = (props) => {
  const { className, text } = props;
  const componentClass = classnames("sal-text-flag", className);

  return <span className={componentClass}>{text}</span>;
};

TextFlag.propTypes = {
  className: PropTypes.string,
  text: PropTypes.string.isRequired,
};

export default TextFlag;
